<div class="store-select-plan-container" (click)="$event.stopPropagation()">
	<div class="texture-background">
		<sp-image [imageFilename]="'texture'" [altImageLabel]="'Texture background'"></sp-image>
	</div>

	<!-- Normal checkout flow -->
	<div class="logo-container">
		<sp-image [imageFilename]="'logo-name'" [altImageLabel]="'Scoutly Plans Logo'"></sp-image>
		<div class="logo-icon-container">
			<sp-image [imageFilename]="'logo-icon'" [altImageLabel]="'Scoutly Plans Logo'"></sp-image>
		</div>
	</div>

	<div class="country-image-container">
		<sp-image class="country-image-line" [imageFilename]="'curved-dash-line'" [altImageLabel]="'dash-line'"></sp-image>
		<div class="country-image-overlay"></div>
		<sp-pill class="country-name-pill" [filename]="'location-on-bkg'" [color]="'yellow'">{{
			countryName() | propertitlecase
		}}</sp-pill>
		<sp-image [imageFilename]="countryNameImage()" [isJpg]="true" [altImageLabel]="'Country image'"></sp-image>
	</div>

	<div class="store-select-plan-title">Start your new chapter</div>
	<div class="store-select-plan-description">
		Experience your future home firsthand before starting your adventure abroad.
	</div>

	<div class="store-select-plan-selection">PLAN SELECTION</div>

	<sp-radio-button-list
		class="product-options"
		[options]="productOptions"
		[(selectedValue)]="selectedProduct"
		(errorState)="handleError($event)"
	>
	</sp-radio-button-list>

	@if (hasValidationError()) {
		<div class="validation-error">Please make a selection</div>
	}

	<sp-progress-dots class="store-select-plan-progress" [currentStep]="0" [totalSteps]="2"></sp-progress-dots>

	<sp-button
		class="pill payment-button"
		[label]="'Continue to Payment'"
		[loading]="isProcessingPayment()"
		[disabled]="disabled() || loading() || isProcessingPayment()"
		[formType]="'button'"
		(clicked)="handleCheckout()"
	></sp-button>

	<sp-button class="text close-button" label="Close" (clicked)="handleClose()"> </sp-button>
</div>
